import {
    GETPROVIDERNAME_SUCCESS,
    GETPROVIDERNAME_FAILED,
    RESET_GETPROVIDERNAME,
    LOADING_GETPROVIDERNAME,
    NETWORK_ERROR_GETPROVIDERNAME
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetProviderNameList = () => {
    return { type: RESET_GETPROVIDERNAME };
};

const getProviderNamesAdminList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETPROVIDERNAME });
    await adminServices
        .post("getProviderName", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminGetProviderNamesuccess(res.data));
                    break;
                default:
                    dispatch(adminGetProviderNameFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETPROVIDERNAME,
                payload: err
            });
        });
};


function adminGetProviderNamesuccess(data) {
    return {
        type: GETPROVIDERNAME_SUCCESS,
        payload: data
    };
}
function adminGetProviderNameFailed(data) {
    return {
        type: GETPROVIDERNAME_FAILED,
        payload: data
    };
}

export { getProviderNamesAdminList, resetAdminGetProviderNameList }